// extracted by mini-css-extract-plugin
export const pillContainer = "pill-module--pill-container--1HShR";
export const pill = "pill-module--pill--3Y2w_";